<template>
  <div
    id="idModalCompanyDrive"
    class="modal-company-drive"
  >
    <div class="wrap-content">
      <div class="d-flex align-items-start justify-content-between">
        <div class="title-modal">
          <img
            src="@/assets/logo/drive-logo.svg"
            alt="drive-logo"
            class="modal-logo"
          >
          <p class="title-text">Drive</p>
        </div>
        <i
          class="fa fa-close close-popup"
          @click="$emit('close-popup', null)"
        />
      </div>

      <div class="d-flex justify-content-between align-items-center">
        <!-- Breadcrumb -->
        <div class="breadcrumbs">
          <ol>
            <li
              v-for="(breadcrumb, index) in breadCrumbs"
              :key="breadcrumb.id"
            >
              <div
                v-if="index !== breadCrumbs.length - 1"
                class="d-flex align-items-center cursor-pointer"
              >
                <div
                  @click="handleChangeFolder(breadcrumb.id)"
                >
                  {{ breadcrumb.name }}
                </div>
                <span> > </span>
              </div>
              <div v-else>{{ breadcrumb.name }}</div>
            </li>
          </ol>
        </div>

        <!-- Search Field -->
        <div class="search-folder">
          <i class="fa fa-search" />
          <input
            v-model="search"
            type="text"
            placeholder="Search..."
            @keyup="handleSearch"
          >
        </div>
      </div>

      <!-- Content Table -->
      <div
        id="wrapTable"
        class="wrap-table-list"
      >
        <table class="table-list">
          <thead>
            <tr>
              <th>Name</th>
              <th>Size</th>
              <th>Created At</th>
              <th>Updated At</th>
            </tr>
          </thead>
          <tbody>
            <!-- If no data -->
            <tr v-if="!isLoading && companyDatas.length === 0">
              <td
                colspan="4"
                style="text-align: center;"
              >
                No data available in table
              </td>
            </tr>

            <template v-if="!isLoading && companyDatas.length > 0">
              <tr
                v-for="data in companyDatas"
                :key="data.id"
                :class="{ 'selected': folderSelected.includes(data.id) }"
                @click="handleClick(data.id, data.kind)"
              >
                <td class="file-name">
                  <img
                    :src="require(`@/assets/icon/${getIcon(data.file_type)}`)"
                    :alt="`icon-${data.name}`"
                  >
                  <span>{{ data.name }}</span>
                </td>
                <td>{{ data.size || '-' }}</td>
                <td>{{ $moment(data.created_at).format('DD MMMM YYYY HH:mm:SS') }}</td>
                <td>{{ $moment(data.updated_at).format('DD MMMM YYYY HH:mm:SS') }}</td>
              </tr>
            </template>

            <!-- Loading Table -->
            <template v-if="isLoading || isLoadingMore">
              <tr
                v-for="i in 6"
                :key="`row-${i}`"
              >
                <td
                  v-for="j in 4"
                  :key="`column-${j}`"
                >
                  <div class="skeleton-table" />
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>

      <div class="d-flex justify-content-end">
        <button
          class="button-border mr-2"
          @click="$emit('close-popup', null)"
        >
          Close
        </button>

        <button
          :disabled="isDisabled"
          class="button-blue"
          @click="selectFolder"
        >
          Select Folder
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import jApiCompanyDrive from '@/services/jApiCompanyDrive';

export default {
  props: {
    isMultiple: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isLoading: true,
      isLoadingMore: false,
      isFirstLoad: true,
      isDisabled: true,
      useInfinityScroll: false,
      parentFolderId: '',
      folderSelected: [],
      paths: [],
      search: '',
      breadCrumbs: [
        {
          id: '',
          name: 'Company Drive',
        },
      ],
      companyDatas: [],
      params: {
        page: 1,
        limit: 100,
        filter: {
          where_is_and: {
            parent_folder_id: '',
          },
        },
      },
      delay: 400,
      clicks: 0,
      timer: null,
    };
  },

  mounted() {
    this.getListCompanyDrive();
    const wrapTable = document.getElementById('wrapTable');
    wrapTable.onscroll = async () => {
      if (this.useInfinityScroll && !this.isFirstLoad) {
        if (wrapTable.scrollHeight - wrapTable.scrollTop === wrapTable.clientHeight) {
          if (!this.isFirstLoad) {
            this.params.page += 1;
            this.isLoadingMore = true;
            this.useInfinityScroll = false;

            const res = await jApiCompanyDrive.getListCompanyDrive(this.params);
            if (!res.error) {
              this.setDataBreadcrumb(res.breadcrumbs);
              if (res.items) {
                this.companyDatas.push(...res.items);
                this.useInfinityScroll = true;
              } else {
                this.useInfinityScroll = false;
              }
              this.isLoadingMore = false;
            }
          }
        }
      }
    };
  },

  methods: {
    async getListCompanyDrive() {
      this.isLoading = true;
      this.isFirstLoad = true;
      this.useInfinityScroll = false;
      const res = await jApiCompanyDrive.getListCompanyDrive(this.params);
      if (!res.error) {
        this.companyDatas = res.items || [];
        this.setDataBreadcrumb(res.breadcrumbs);
        this.useInfinityScroll = true;
        this.isLoading = false;
        this.isFirstLoad = false;
      }
    },

    setDataBreadcrumb(data) {
      const firstBreadcrumb = {
        id: '',
        name: 'Company Drive',
      };
      if (data.length > 0) {
        this.breadCrumbs = [firstBreadcrumb, ...data];
      } else {
        this.breadCrumbs = [firstBreadcrumb];
      }
    },

    async handleSearch() {
      if (this.search.length > 2) {
        const param = {
          page: 1,
          limit: 10,
          filter: {
            where_like_and: {
              kind: 'folder',
              name: this.search,
            },
          },
        };
        this.useInfinityScroll = false;
        const res = await jApiCompanyDrive.getListCompanyDrive(param);
        if (!res.error) this.companyDatas = res.items || [];
      } else if (this.search.length === 0) {
        this.getListCompanyDrive();
      }
    },

    handleChangeFolder(id) {
      if (!id) this.breadCrumbs = [];
      this.paths = [];
      this.parentFolderId = id;
      this.params.page = 1;
      this.params.filter.where_is_and.parent_folder_id = id;
      this.getListCompanyDrive();
    },

    async handleSelectFolder(id) {
      let findIndex = null;
      let isGotSameData = false;

      if (!this.isMultiple) {
        this.folderSelected = [id];
      } else {
        findIndex = this.folderSelected.findIndex(f => f === id);
        if (findIndex > -1) {
          this.folderSelected.splice(findIndex, 1);
          isGotSameData = true;
        } else {
          this.folderSelected.push(id);
        }
      }

      if (!isGotSameData) {
        this.isDisabled = true;
        const param = {
          page: 1,
          limit: 1,
          filter: {
            where_is_and: {
              kind: 'folder',
              parent_folder_id: id,
            },
          },
        };
        const res = await jApiCompanyDrive.getListCompanyDrive(param);
        if (!res.error) {
          const breadcrumb = res.breadcrumbs.map(b => b.name);
          const path = `"/${breadcrumb.join('/')}"`;
          if (!this.isMultiple) this.paths = [path];
          else this.paths.push(path);
          this.isDisabled = false;
        }
      } else if (isGotSameData) {
        this.paths.splice(findIndex, 1);
      }
    },

    handleClick(id, type) {
      // eslint-disable-next-line no-plusplus
      this.clicks++;
      if (this.clicks === 1) {
        this.timer = setTimeout(() => {
          this.handleSelectFolder(id);
          this.clicks = 0;
        }, this.delay);
      } else {
        clearTimeout(this.timer);
        if (type === 'folder') this.handleChangeFolder(id);
        else this.handleSelectFolder(id);
        this.clicks = 0;
      }
    },

    selectFolder() {
      if (!this.isMultiple) {
        this.$emit('close-popup', `${this.paths[0].replace(/'/g, '')}`);
      } else {
        this.$emit('close-popup', `[${this.paths.join(', ')}]`);
      }
    },

    getIcon(type) {
      if (type === 'txt') {
        return 'file-txt.svg';
      } else if (type === 'csv') {
        return 'file-csv.svg';
      } else if (type === 'pdf') {
        return 'file-pdf.svg';
      } else if (type === 'xls' || type === 'xlsx') {
        return 'file-xls.svg';
      } else if (type === 'ppt' || type === 'pptx') {
        return 'file-ppt.svg';
      } else if (type === 'doc' || type === 'docx') {
        return 'file-doc.svg';
      } else if (type === 'jpg' || type === 'jpeg' || type === 'png' || type === 'svg' || type === 'bmp') {
        return 'file-image.svg';
      } else if (type === 'mp3' || type === 'aac' || type === 'wav' || type === 'wma' || type === 'ogg') {
        return 'file-music.svg';
      } else if (type === 'mp4' || type === 'mov' || type === 'wmv' || type === 'avi' || type === 'mkv' || type === 'webm' || type === 'flv' || type === 'mpeg4') {
        return 'file-music.svg';
      } else if (type === 'zip' || type === 'zipx' || type === 'tar' || type === 'gz' || type === 'rar' || type === '7z' || type === 'iso') {
        return 'file-zip.svg';
      }
      return 'file-folder.svg';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/visual-programming/popup/ModalCompanyDrive.vue